import CountrySelectAsync, { CountrySelectAsyncProps } from "./CountrySelectAsync";
import CountrySelectBase, { CountrySelectBaseProps } from "./CountrySelectBase";
import CountrySelectPreset, { CountrySelectPresetProps } from "./CountrySelectPreset";

/**
 * Used for CRMIS apps, by default has crmis specific styling and behaviour
 * Styles can be tweaked by using CustomSelect
 * Might be deprecated in future
 */
const CountrySelect = (props: CountrySelectBaseProps | CountrySelectAsyncProps | CountrySelectPresetProps): JSX.Element => {
  if (('countries' in props) && Array.isArray(props.countries)) return <CountrySelectBase {...props as CountrySelectBaseProps} />;
  if (('countries' in props) && props.countries instanceof Promise) return <CountrySelectAsync {...props as CountrySelectAsyncProps} />
  return <CountrySelectPreset {...props as CountrySelectPresetProps} />
}

export default CountrySelect;
